module.exports = {"620824001":"东华街道","620824100":"东华镇","620824101":"安口镇","620824102":"西华镇","620824103":"马峡镇","620824104":"策底镇","620824105":"上关镇","620824106":"河西镇","620824201":"神峪乡","620824202":"山寨乡","620824204":"砚峡乡","620824400":"石堡子开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620824.json
// module id = 2716
// module chunks = 0